import React, { FC } from 'react';

import { styled } from '../theme';

export type BackdropProps = React.HTMLAttributes<HTMLDivElement> & {
    isVisible: boolean;
    className?: string;
};

const StyledBackdrop = styled('div', {
    shouldForwardProp: (prop) => prop !== 'isVisible',
})<{ isVisible: boolean }>`
    position: fixed;
    inset: 0;
    background: rgba(22, 25, 28, 0.85);
    z-index: ${({ theme }) => theme.zIndex.backdrop};
    opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
    transition: opacity 0.3s ease;
    pointer-events: ${({ isVisible }) => (isVisible ? 'auto' : 'none')};
`;

const Backdrop: FC<BackdropProps> = ({ isVisible, className, ...props }) => {
    return <StyledBackdrop className={className} isVisible={isVisible} {...props} />;
};

export default Backdrop;
